module.exports = __webpack_public_path__ + "media/images/categories/headers/society-and-the-wider-world-9d048428d8cf113ca97565c4077906b1.jpg";